/* Generate this object in a C# .Net environment like https://dotnetfiddle.net/
using System;
using System.Linq;
					
public class Program
{
	public static void Main()
	{
		System.Globalization.CultureInfo[] allCultures = System.Globalization.CultureInfo.GetCultures(System.Globalization.CultureTypes.NeutralCultures);
		var json = "{" + allCultures
			.GroupBy(c => c.TwoLetterISOLanguageName)
			.Select(g => "\n\t" + g.Key + ":" + new String(' ', 4 - g.Key.Length)
				+ "{"
					+ "name: \"" + g.First().EnglishName + "\", "
					+ "nativeName: \"" + g.First().NativeName + "\""
					+ (g.First().TextInfo.IsRightToLeft ? ", isRightToLeft: true" : "")
				+ "}")
			.Aggregate((a, b) => a + ", " + b)+ "\n}";
		Console.WriteLine(json);
	}
} */
export const CULTURE_INFO: {
    [code: string]: { name: string; nativeName: string; isRightToLeft?: boolean };
} = {
    iv: {
        name: "Invariant Language (Invariant Country)",
        nativeName: "Invariant Language (Invariant Country)",
    },
    aa: { name: "Afar", nativeName: "Qafar" },
    af: { name: "Afrikaans", nativeName: "Afrikaans" },
    agq: { name: "Aghem", nativeName: "Aghem" },
    ak: { name: "Akan", nativeName: "Akan" },
    am: { name: "Amharic", nativeName: "አማርኛ" },
    ar: { name: "Arabic", nativeName: "العربية", isRightToLeft: true },
    arn: { name: "Mapudungun", nativeName: "Mapudungun" },
    as: { name: "Assamese", nativeName: "অসমীয়া" },
    asa: { name: "Asu", nativeName: "Kipare" },
    ast: { name: "Asturian", nativeName: "Asturianu" },
    az: { name: "Azerbaijani", nativeName: "Azərbaycan dili" },
    ba: { name: "Bashkir", nativeName: "Башҡорт" },
    bas: { name: "Basaa", nativeName: "Ɓàsàa" },
    be: { name: "Belarusian", nativeName: "Беларуская" },
    bem: { name: "Bemba", nativeName: "Ichibemba" },
    bez: { name: "Bena", nativeName: "Hibena" },
    bg: { name: "Bulgarian", nativeName: "Български" },
    bin: { name: "Edo", nativeName: "Ẹ̀dó" },
    bm: { name: "Bamanankan", nativeName: "Bamanakan" },
    bn: { name: "Bangla", nativeName: "বাংলা" },
    bo: { name: "Tibetan", nativeName: "བོད་ཡིག" },
    br: { name: "Breton", nativeName: "Brezhoneg" },
    brx: { name: "Bodo", nativeName: "बड़ो" },
    bs: { name: "Bosnian", nativeName: "Bosanski" },
    byn: { name: "Blin", nativeName: "ብሊን" },
    ca: { name: "Catalan", nativeName: "Català" },
    ce: { name: "Chechen", nativeName: "Нохчийн" },
    cgg: { name: "Chiga", nativeName: "Rukiga" },
    chr: { name: "Cherokee", nativeName: "ᏣᎳᎩ" },
    co: { name: "Corsican", nativeName: "Corsu" },
    cs: { name: "Czech", nativeName: "Čeština" },
    cu: { name: "Church Slavic", nativeName: "Церковнослове́нскїй" },
    cy: { name: "Welsh", nativeName: "Cymraeg" },
    da: { name: "Danish", nativeName: "Dansk" },
    dav: { name: "Taita", nativeName: "Kitaita" },
    de: { name: "German", nativeName: "Deutsch" },
    dje: { name: "Zarma", nativeName: "Zarmaciine" },
    dsb: { name: "Lower Sorbian", nativeName: "Dolnoserbšćina" },
    dua: { name: "Duala", nativeName: "Duálá" },
    dv: { name: "Divehi", nativeName: "ދިވެހިބަސް", isRightToLeft: true },
    dyo: { name: "Jola-Fonyi", nativeName: "Joola" },
    dz: { name: "Dzongkha", nativeName: "རྫོང་ཁ" },
    ebu: { name: "Embu", nativeName: "Kĩembu" },
    ee: { name: "Ewe", nativeName: "Eʋegbe" },
    el: { name: "Greek", nativeName: "Ελληνικά" },
    en: { name: "English", nativeName: "English" },
    eo: { name: "Esperanto", nativeName: "Esperanto" },
    es: { name: "Spanish", nativeName: "Español" },
    et: { name: "Estonian", nativeName: "Eesti" },
    eu: { name: "Basque", nativeName: "Euskara" },
    ewo: { name: "Ewondo", nativeName: "Ewondo" },
    fa: { name: "Persian", nativeName: "فارسى", isRightToLeft: true },
    ff: { name: "Fulah", nativeName: "Fulah" },
    fi: { name: "Finnish", nativeName: "Suomi" },
    fil: { name: "Filipino", nativeName: "Filipino" },
    fo: { name: "Faroese", nativeName: "Føroyskt" },
    fr: { name: "French", nativeName: "Français" },
    fur: { name: "Friulian", nativeName: "Furlan" },
    fy: { name: "Western Frisian", nativeName: "Frysk" },
    ga: { name: "Irish", nativeName: "Gaeilge" },
    gd: { name: "Scottish Gaelic", nativeName: "Gàidhlig" },
    gl: { name: "Galician", nativeName: "Galego" },
    gn: { name: "Guarani", nativeName: "Avañe’ẽ" },
    gsw: { name: "Alsatian", nativeName: "Elsässisch" },
    gu: { name: "Gujarati", nativeName: "ગુજરાતી" },
    guz: { name: "Gusii", nativeName: "Ekegusii" },
    gv: { name: "Manx", nativeName: "Gaelg" },
    ha: { name: "Hausa", nativeName: "Hausa" },
    haw: { name: "Hawaiian", nativeName: "ʻŌlelo Hawaiʻi" },
    he: { name: "Hebrew", nativeName: "עברית", isRightToLeft: true },
    hi: { name: "Hindi", nativeName: "हिंदी" },
    hr: { name: "Croatian", nativeName: "Hrvatski" },
    hsb: { name: "Upper Sorbian", nativeName: "Hornjoserbšćina" },
    hu: { name: "Hungarian", nativeName: "Magyar" },
    hy: { name: "Armenian", nativeName: "Հայերեն" },
    ia: { name: "Interlingua", nativeName: "Interlingua" },
    ibb: { name: "Ibibio", nativeName: "Ibibio-Efik" },
    id: { name: "Indonesian", nativeName: "Indonesia" },
    ig: { name: "Igbo", nativeName: "Igbo" },
    ii: { name: "Yi", nativeName: "ꆈꌠꁱꂷ" },
    is: { name: "Icelandic", nativeName: "Íslenska" },
    it: { name: "Italian", nativeName: "Italiano" },
    iu: { name: "Inuktitut", nativeName: "Inuktitut" },
    ja: { name: "Japanese", nativeName: "日本語" },
    jgo: { name: "Ngomba", nativeName: "Ndaꞌa" },
    jmc: { name: "Machame", nativeName: "Kimachame" },
    jv: { name: "Javanese", nativeName: "Basa Jawa" },
    ka: { name: "Georgian", nativeName: "Ქართული" },
    kab: { name: "Kabyle", nativeName: "Taqbaylit" },
    kam: { name: "Kamba", nativeName: "Kikamba" },
    kde: { name: "Makonde", nativeName: "Chimakonde" },
    kea: { name: "Kabuverdianu", nativeName: "Kabuverdianu" },
    khq: { name: "Koyra Chiini", nativeName: "Koyra ciini" },
    ki: { name: "Kikuyu", nativeName: "Gikuyu" },
    kk: { name: "Kazakh", nativeName: "Қазақ тілі" },
    kkj: { name: "Kako", nativeName: "Kakɔ" },
    kl: { name: "Greenlandic", nativeName: "Kalaallisut" },
    kln: { name: "Kalenjin", nativeName: "Kalenjin" },
    km: { name: "Khmer", nativeName: "ភាសាខ្មែរ" },
    kn: { name: "Kannada", nativeName: "ಕನ್ನಡ" },
    ko: { name: "Korean", nativeName: "한국어" },
    kok: { name: "Konkani", nativeName: "कोंकणी" },
    kr: { name: "Kanuri", nativeName: "Kanuri" },
    ks: { name: "Kashmiri", nativeName: "کٲشُر" },
    ksb: { name: "Shambala", nativeName: "Kishambaa" },
    ksf: { name: "Bafia", nativeName: "Rikpa" },
    ksh: { name: "Ripuarian", nativeName: "Kölsch" },
    ku: { name: "Central Kurdish", nativeName: "کوردیی ناوەڕاست", isRightToLeft: true },
    kw: { name: "Cornish", nativeName: "Kernewek" },
    ky: { name: "Kyrgyz", nativeName: "Кыргыз" },
    la: { name: "Latin", nativeName: "Lingua latīna" },
    lag: { name: "Langi", nativeName: "Kɨlaangi" },
    lb: { name: "Luxembourgish", nativeName: "Lëtzebuergesch" },
    lg: { name: "Ganda", nativeName: "Luganda" },
    lkt: { name: "Lakota", nativeName: "Lakȟólʼiyapi" },
    ln: { name: "Lingala", nativeName: "Lingála" },
    lo: { name: "Lao", nativeName: "ລາວ" },
    lrc: { name: "Northern Luri", nativeName: "لۊری شومالی" },
    lt: { name: "Lithuanian", nativeName: "Lietuvių" },
    lu: { name: "Luba-Katanga", nativeName: "Tshiluba" },
    luo: { name: "Luo", nativeName: "Dholuo" },
    luy: { name: "Luyia", nativeName: "Luluhia" },
    lv: { name: "Latvian", nativeName: "Latviešu" },
    mas: { name: "Masai", nativeName: "Maa" },
    mer: { name: "Meru", nativeName: "Kĩmĩrũ" },
    mfe: { name: "Morisyen", nativeName: "Kreol morisien" },
    mg: { name: "Malagasy", nativeName: "Malagasy" },
    mgh: { name: "Makhuwa-Meetto", nativeName: "Makua" },
    mgo: { name: "Metaʼ", nativeName: "Metaʼ" },
    mi: { name: "Maori", nativeName: "Reo Māori" },
    mk: { name: "Macedonian", nativeName: "Македонски" },
    ml: { name: "Malayalam", nativeName: "മലയാളം" },
    mn: { name: "Mongolian", nativeName: "Монгол хэл" },
    mni: { name: "Manipuri", nativeName: "মৈতৈলোন্" },
    moh: { name: "Mohawk", nativeName: "Kanien’kéha" },
    mr: { name: "Marathi", nativeName: "मराठी" },
    ms: { name: "Malay", nativeName: "Bahasa Melayu" },
    mt: { name: "Maltese", nativeName: "Malti" },
    mua: { name: "Mundang", nativeName: "MUNDAŊ" },
    my: { name: "Burmese", nativeName: "ဗမာ" },
    mzn: { name: "Mazanderani", nativeName: "مازرونی" },
    naq: { name: "Nama", nativeName: "Khoekhoegowab" },
    nb: { name: "Norwegian Bokmål", nativeName: "Norsk bokmål" },
    nd: { name: "North Ndebele", nativeName: "IsiNdebele" },
    ne: { name: "Nepali", nativeName: "नेपाली" },
    nl: { name: "Dutch", nativeName: "Nederlands" },
    nmg: { name: "Kwasio", nativeName: "Kwasio" },
    nn: { name: "Norwegian Nynorsk", nativeName: "Nynorsk" },
    nnh: { name: "Ngiemboon", nativeName: "Shwóŋò ngiembɔɔn" },
    nqo: { name: "N'ko", nativeName: "ߒߞߏ", isRightToLeft: true },
    nr: { name: "South Ndebele", nativeName: "IsiNdebele" },
    nso: { name: "Sesotho sa Leboa", nativeName: "Sesotho sa Leboa" },
    nus: { name: "Nuer", nativeName: "Thok Nath" },
    nyn: { name: "Nyankole", nativeName: "Runyankore" },
    oc: { name: "Occitan", nativeName: "Occitan" },
    om: { name: "Oromo", nativeName: "Oromoo" },
    or: { name: "Odia", nativeName: "ଓଡ଼ିଆ" },
    os: { name: "Ossetian", nativeName: "Ирон æвзаг" },
    pa: { name: "Punjabi", nativeName: "ਪੰਜਾਬੀ" },
    pap: { name: "Papiamento", nativeName: "Papiamentu" },
    pl: { name: "Polish", nativeName: "Polski" },
    prg: { name: "Prussian", nativeName: "Prūsiskan" },
    prs: { name: "Dari", nativeName: "درى", isRightToLeft: true },
    ps: { name: "Pashto", nativeName: "پښتو", isRightToLeft: true },
    pt: { name: "Portuguese(Brazil)", nativeName: "Português(Brasil)" },
    quc: { name: "K'iche'", nativeName: "K'iche'" },
    quz: { name: "Quechua", nativeName: "Runasimi" },
    rm: { name: "Romansh", nativeName: "Rumantsch" },
    rn: { name: "Rundi", nativeName: "Ikirundi" },
    ro: { name: "Romanian", nativeName: "Română" },
    rof: { name: "Rombo", nativeName: "Kihorombo" },
    ru: { name: "Russian", nativeName: "Русский" },
    rw: { name: "Kinyarwanda", nativeName: "Kinyarwanda" },
    rwk: { name: "Rwa", nativeName: "Kiruwa" },
    sa: { name: "Sanskrit", nativeName: "संस्कृत" },
    sah: { name: "Sakha", nativeName: "Саха" },
    saq: { name: "Samburu", nativeName: "Kisampur" },
    sbp: { name: "Sangu", nativeName: "Ishisangu" },
    sd: { name: "Sindhi", nativeName: "سنڌي", isRightToLeft: true },
    se: { name: "Northern Sami", nativeName: "Davvisámegiella" },
    seh: { name: "Sena", nativeName: "Sena" },
    ses: { name: "Koyraboro Senni", nativeName: "Koyraboro senni" },
    sg: { name: "Sango", nativeName: "Sängö" },
    shi: { name: "Tachelhit", nativeName: "ⵜⴰⵛⵍⵃⵉⵜ" },
    si: { name: "Sinhala", nativeName: "සිංහල" },
    sk: { name: "Slovak", nativeName: "Slovenčina" },
    sl: { name: "Slovenian", nativeName: "Slovenščina" },
    sma: { name: "Sami (Southern)", nativeName: "Åarjelsaemiengïele" },
    smj: { name: "Sami (Lule)", nativeName: "Julevusámegiella" },
    smn: { name: "Sami (Inari)", nativeName: "Anarâškielâ" },
    sms: { name: "Sami (Skolt)", nativeName: "Sää´mǩiõll" },
    sn: { name: "Shona", nativeName: "ChiShona" },
    so: { name: "Somali", nativeName: "Soomaali" },
    sq: { name: "Albanian", nativeName: "Shqip" },
    sr: { name: "Serbian", nativeName: "Srpski" },
    ss: { name: "siSwati", nativeName: "Siswati" },
    ssy: { name: "Saho", nativeName: "Saho" },
    st: { name: "Sesotho", nativeName: "Sesotho" },
    sv: { name: "Swedish", nativeName: "Svenska" },
    sw: { name: "Kiswahili", nativeName: "Kiswahili" },
    syr: { name: "Syriac", nativeName: "ܣܘܪܝܝܐ", isRightToLeft: true },
    ta: { name: "Tamil", nativeName: "தமிழ்" },
    te: { name: "Telugu", nativeName: "తెలుగు" },
    teo: { name: "Teso", nativeName: "Kiteso" },
    tg: { name: "Tajik", nativeName: "Тоҷикӣ" },
    th: { name: "Thai", nativeName: "ไทย" },
    ti: { name: "Tigrinya", nativeName: "ትግርኛ" },
    tig: { name: "Tigre", nativeName: "ትግረ" },
    tk: { name: "Turkmen", nativeName: "Türkmen dili" },
    tn: { name: "Setswana", nativeName: "Setswana" },
    to: { name: "Tongan", nativeName: "Lea fakatonga" },
    tr: { name: "Turkish", nativeName: "Türkçe" },
    ts: { name: "Tsonga", nativeName: "Xitsonga" },
    tt: { name: "Tatar", nativeName: "Татар" },
    twq: { name: "Tasawaq", nativeName: "Tasawaq senni" },
    tzm: { name: "Central Atlas Tamazight", nativeName: "Tamaziɣt n laṭlaṣ" },
    ug: { name: "Uyghur", nativeName: "ئۇيغۇرچە", isRightToLeft: true },
    uk: { name: "Ukrainian", nativeName: "Українська" },
    ur: { name: "Urdu", nativeName: "اُردو", isRightToLeft: true },
    uz: { name: "Uzbek", nativeName: "O‘zbek" },
    vai: { name: "Vai", nativeName: "ꕙꔤ" },
    ve: { name: "Venda", nativeName: "Tshivenḓa" },
    vi: { name: "Vietnamese", nativeName: "Tiếng Việt" },
    vo: { name: "Volapük", nativeName: "Volapük" },
    vun: { name: "Vunjo", nativeName: "Kyivunjo" },
    wae: { name: "Walser", nativeName: "Walser" },
    wal: { name: "Wolaytta", nativeName: "ወላይታቱ" },
    wo: { name: "Wolof", nativeName: "Wolof" },
    xh: { name: "isiXhosa", nativeName: "IsiXhosa" },
    xog: { name: "Soga", nativeName: "Olusoga" },
    yav: { name: "Yangben", nativeName: "Nuasue" },
    yi: { name: "Yiddish", nativeName: "ייִדיש", isRightToLeft: true },
    yo: { name: "Yoruba", nativeName: "Èdè Yorùbá" },
    zgh: { name: "Standard Moroccan Tamazight", nativeName: "ⵜⴰⵎⴰⵣⵉⵖⵜ" },
    zh: { name: "Chinese", nativeName: "中文" },
    zu: { name: "isiZulu", nativeName: "IsiZulu" },

    /* Extended Language List From Azure Translation */
    yue: { name: "Cantonais", nativeName: "粤语" },
    mww: { name: "Daw Hmong", nativeName: "Hmong Daw" },
    ikt: { name: "Inuinnaqtun", nativeName: "Inuinnaqtun" },
    yua: { name: "Yucatec Maya", nativeName: "mayaʼ tʼàan" },
    kmr: { name: "Kurdish(Northern)", nativeName: "كوردی" },
    lzh: { name: "Chinese(Literary)", nativeName: "中文(文言文)" },
    "tlh-latn": { name: "Klingon", nativeName: "tlhIngan Hol" },
    "tlh-piqd": { name: "Klingon(plqaD)", nativeName: "tlhIngan Hol(plqaD)" },
    "fr-ca": { name: "French(Canada)", nativeName: "Français(Canada)" },
    "iu-latn": { name: "Inuktitut(Latin)", nativeName: "Inuktitut(Latin)" },
    "pt-pt": { name: "Portuguese", nativeName: "Português" },
    "zh-hans": { name: "Chinese Traditional", nativeName: "中文(简体)" },
    "zh-hant": { name: "Chinese Simplified", nativeName: "中文(繁體)" },
    "mn-cyrl": { name: "Mongolian(Cyrillic)", nativeName: "Монгол хэл(Cyrillic)" },
    "mn-mong": { name: "Mongolian(Traditional)", nativeName: "Монгол хэл(Traditional)" },
    "sr-cyrl": { name: "Serbian(Cyrillic)", nativeName: "Srpski(cyrillique)" },
    "sr-latn": { name: "Serbian(Latin)", nativeName: "Srpski(Latin)" },

    ab: { name: "Abkhazian", nativeName: "Аҧсуа" },
    ae: { name: "Avestan", nativeName: "Avesta" },
    an: { name: "Aragonés", nativeName: "Aragonese" },
    av: { name: "Avaric", nativeName: "авар мацӀ ; магӀарул мацӀ" },
    ay: { name: "Aymara", nativeName: "Aymar aru" },
    bh: { name: "Bihari", nativeName: "भोजपुरी" },
    bi: { name: "Bislama", nativeName: "Bislama" },
    ch: { name: "Chamorro", nativeName: "Chamorro" },
    cr: { name: "Cree", nativeName: "ᐦᐃᔭᐍᐏᐣ" },
    cv: { name: "Chuvash", nativeName: "чӑваш чӗлхи" },
    fj: { name: "Fijian", nativeName: "Vosa Vakaviti" },
    ho: { name: "Hiri Motu", nativeName: "Hiri Motu" },
    ht: { name: "Haitian", nativeName: "Kreyòl ayisyen" },
    hz: { name: "Herero", nativeName: "Otjiherero" },
    ie: { name: "Interlingue", nativeName: "Interlingue" },
    ik: { name: "Inupiaq", nativeName: "Iñupiaq ; Iñupiatun" },
    io: { name: "Ido", nativeName: "Ido" },
    kg: { name: "Kongo", nativeName: "KiKongo" },
    kj: { name: "Kwanyama", nativeName: "Kuanyama" },
    kv: { name: "Komi", nativeName: "коми кыв" },
    li: { name: "Limburgish", nativeName: "Limburgs" },
    mh: { name: "Marshallese", nativeName: "Kajin M̧ajeļ" },
    mo: { name: "Moldavian", nativeName: "лимба молдовеняскэ" },
    na: { name: "Nauru", nativeName: "Ekakairũ Naoero" },
    ng: { name: "Ndonga", nativeName: "Owambo" },
    no: { name: "Norwegian", nativeName: "Norsk" },
    nv: { name: "Navajo", nativeName: "Diné bizaad ; Dinékʼehǰí" },
    ny: { name: "Chichewa", nativeName: "ChiCheŵa ; chinyanja" },
    oj: { name: "Ojibwa", nativeName: "ᐊᓂᔑᓈᐯᒧᐎᓐ" },
    pi: { name: "Pāli", nativeName: "पािऴ" },
    qu: { name: "Quechua", nativeName: "Runa Simi ; Kichwa" },
    sc: { name: "Sardinian", nativeName: "sardu" },
    sh: { name: "Serbo-Croatian", nativeName: "Српскохрватски" },
    sm: { name: "Samoan", nativeName: "Gagana fa''a Samoa" },
    su: { name: "Sundanese", nativeName: "Basa Sunda" },
    tl: { name: "Tagalog", nativeName: "Tagalog" },
    tw: { name: "Twi", nativeName: "Twi" },
    ty: { name: "Tahitian", nativeName: "Reo Mā`ohi" },
    wa: { name: "Walloon", nativeName: "Walon" },
    za: { name: "Zhuang", nativeName: "Saw cueŋƅ ; Saw cuengh" },
};
